exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".techHeader {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    text-align: center;\r\n    min-height: 85vh;\r\n    color: #242D4B;\r\n    flex-direction: column;\r\n}\r\n\r\n.techText {\r\n    font-size: 24px;\r\n}\r\n\r\n.grid {\r\n    width: 100%;\r\n}\r\n\r\n.techBorder {\r\n    border: 2px solid #242D4B;\r\n    border-radius: 5px;\r\n    padding: 24px;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./App/containers/banner/banner.css
// module id = 1340
// module chunks = 0